import React, { useRef, useEffect } from 'react'
import RightArrow from '../Icons/RightArrow'
import Badge from '../Badge'
import ChatButton from '../ChatButton'
import DanteLogoIcon from '../Icons/DanteLogoIcon'
import LeftArrowIcon from '../Icons/LeftArrowIcon'

const PreviousConversations = ({
  conversations = [],
  onConversationClick,
  onNavigate,
  className = "",
  config,
  resetCurrentConversation,
  setCurrentConversation,
  showBackButton = false
}) => {
  const displayConversations = conversations

  const scrollContainerRef = useRef(null)

  // Function to scroll to bottom with smooth animation
  const scrollToBottom = (smooth = true) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: smooth ? 'smooth' : 'instant'
      })
    }
  }

  useEffect(() => {
    scrollToBottom()
  }, [conversations])

  useEffect(() => {
   
    const timer = setTimeout(() => {
      scrollToBottom(false) 
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  const handleConversationClick = (conversation) => {
    if (onConversationClick) {
      onConversationClick(conversation)
    }
  }
  return (
    <div
      className={`flex flex-col justify-between w-full relative h-full ${className}`}
      style={{ backgroundColor: config?.surface_color || '#ffffff' }}
    >
      {/* Header with back button - only show for direct link */}
      {showBackButton && (
        <div className="flex items-center gap-v3-sm px-v3-sm py-v3-sm border-b border-[--dt-color-element-10]">
          <button
            onClick={() => {
              if (onNavigate) {
                onNavigate('chat');
              }
            }}
            className="flex w-v3-lg h-v3-lg justify-center items-center gap-v3-xs aspect-square rounded-v3-sm transition-colors hover:bg-[--dt-color-element-5]"
          >
            <LeftArrowIcon className="text-[--dt-color-element-100]" />
          </button>
          <h2 className="text-v3-h6 font-medium text-[--dt-color-element-100]">Previous Conversations</h2>
        </div>
      )}

      <div ref={scrollContainerRef} className='overflow-y-auto no-scrollbar h-full '>
          {displayConversations.map((conversation, index) => (
        <div
          key={conversation.id}
          onClick={() => handleConversationClick(conversation)}
          className={`flex items-center gap-v3-sm p-v3-sm  hover:bg-[var(--hover-bg-color)] transition-colors duration-200 cursor-pointer group ${
            index < displayConversations.length - 1 ? 'border-b border-v3-black-border' : ''
          }`}
          style={{
            '--hover-bg-color': config?.response_background_color || 'var(--v3-black-card)',
          }}
        >
          {/* Avatar */}
          <div className="flex-shrink-0 w-v3-xl h-v3-xl rounded-full bg-[#FFFFFF] flex items-center justify-center shadow-v3-card-wrapper">
            {config?.chatbot_icon ? (
              <img
                src={config.chatbot_icon instanceof File ? URL.createObjectURL(config.chatbot_icon) : config.chatbot_icon}
                alt="Chatbot Icon"
                className="w-full h-full object-cover rounded-full"
              />
            ) : <DanteLogoIcon className="w-v3-lg h-v3-lg" />}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0 font-inter-variable">
            <h3 className="text-v3-h6 font-medium text-[var(--dt-color-element-100)] truncate mb-v3-xxs">
              {conversation.title}
            </h3>
            <div className="flex flex-wrap items-center gap-v3-xs text-v3-black-fixed-secondary">
              <span className="text-sm">
                {conversation.agent}
              </span>
              <span className="text-sm text-v3-black-inactive">•</span>
              <span className="text-sm">
                {conversation.agentType}
              </span>
              <span className="text-sm text-v3-black-inactive">•</span>
              <span className="text-sm">
                {conversation.timestamp}
              </span>
            </div>
          </div>

          {/* Arrow with optional badge */}
          <div className="flex-shrink-0">
            {conversation.badge ? (
              <div className="flex items-center gap-v3-xs">
                <Badge>{conversation.badge}</Badge>
               </div>
            ) : (
              <RightArrow className='text-v3-black-dark' />
            )}
          </div>
        </div>
      ))}
       </div>

     
      <div className="flex justify-center py-v3-md">
        <ChatButton
          label={config?.ask_a_question_button || "Ask a question"}
          config={config}
          onClick={() => {
            resetCurrentConversation()
            // Explicitly set the type to 'new' to trigger creation of a new conversation
            setCurrentConversation({ id: null, type: 'new' });
            if (onNavigate) {
              onNavigate('chat');
            }
          }}
        />
      </div>
    </div>
  )
}

export default PreviousConversations